<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 col-xl-6 offset-xl-3">
          <card>
            <template slot="header">
              <h4 class="card-title">Resetta password</h4>
              <p v-if="loading && !tokenVerificato" class="card-category">
                <center>Caricamento in corso...</center>
              </p>
              <form class="login-form" v-if="tokenVerificato && !passwordModificata">
                <div class="row">
                  <div class="col-12">
                    <fg-input type="password"
                      label="Nuova Password"
                      placeholder="Password"
                      v-model="password"
                      :disabled="loading">
                    </fg-input>
                  </div>
                  <div class="col-12">
                    <fg-input type="password"
                      label="Ripeti la password"
                      placeholder="Password"
                      v-model="password2"
                      :disabled="loading">
                    </fg-input>
                  </div>
                  <div class="col-12">
                    <button type="submit" :disabled="loading" class="btn btn-info btn-fill float-right" @click.prevent="salva">
                      Salva
                    </button>
                  </div>
                </div>
              </form>
              <p>{{ messaggioErrore }}</p>
              <p v-if="passwordModificata">La nuova password è stata salvata</p>
            </template>
          </card>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-xl-6 offset-xl-3" style="padding:0px 30px;">
          <a href="#/login">Torna alla pagina di login</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Card from 'src/components/UIComponents/Cards/Card.vue'

  export default {
    components: {
      Card
    },
    data () {
      return {
        loading: true,
        password: '',
        password2: '',
        tokenVerificato: false,
        messaggioErrore: '',
        passwordModificata: false
      }
    },
    mounted () {
      var me = this
      var url = process.env.API_URL + 'auth/user/checktokenreset?token=' + me.$route.query.token
      var method = 'POST'
      var params = {}
      var successFn = function (data) {
        me.$data.tokenVerificato = true
        me.$data.loading = false
      }
      var errorFn = function (message) {
        me.$data.loading = false
        if (message) {
          me.$data.messaggioErrore = message
        } else {
          me.ajaxErrorFn(message)
        }
      }
      me.ajax(url, method, params, successFn, errorFn)
    },
    methods: {
      salva: function (event) {
        var me = this
        me.$data.loading = true
        var url = process.env.API_URL + 'auth/user/resetpassword'
        var method = 'POST'
        if (me.$data.password !== me.$data.password2) {
          me.ajaxErrorFn('Le password inserite sono differenti')
          me.$data.loading = false
          return
        }
        var params = {
          password: me.$data.password,
          token: me.$route.query.token
        }
        var successFn = function (data) {
          me.$data.passwordModificata = true
          me.$data.loading = false
        }
        var errorFn = function (message) {
          me.ajaxErrorFn(message)
          me.$data.loading = false
        }
        me.$root.ajax(url, method, params, successFn, errorFn)
      }
    }
  }

</script>
<style>
.login-form .form-check {
  padding-left: 0px;
}
.login-form .form-check .form-check-label{
  line-height: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/GeneralViews/PasswordReset.vue